import { SquaredCross } from "@styled-icons/entypo/SquaredCross";

import { Box } from "rebass";

export function EnqueteStatusInvalidIcon() {
  return (
    <Box
      sx={{
        color: "#B91605",
        width: "18px",
      }}
    >
      <SquaredCross />
    </Box>
  );
}
